
import { mapState, mapActions } from 'vuex';

export default {
  name: 'SessionExpiry',
  data() {
    return {
      timer: null,
      minutes: null,
      isOpen: false,
    };
  },
  computed: {
    ...mapState('user', ['user']),
  },
  created() {
    this.isOpen = false;
    this.checkSession();
    this.timer = setInterval(() => {
      this.checkSession();
    }, 60000); // runs every minute
  },

  beforeDestroy() {
    clearInterval(this.timer);
  },

  methods: {
    ...mapActions('user', ['logExtendSession']),

    checkSession() {
      // If the user has a remember me cookie, we can delay warning the user their session is expiring until then.
      // Otherwise, we need to warn them based on the session cookie expiry.
      const sessionExpiry = this.$authService.rememberExpiry?.isAfter(this.$authService.sessionExpiry)
        ? this.$authService.rememberExpiry
        : this.$authService.sessionExpiry;

      this.minutes = sessionExpiry.diff(this.$dayjs(), 'minutes');

      if (this.minutes <= 0) {
        this.$nuxt.$authService.logout();
      }

      if (this.minutes <= 5) {
        this.isOpen = true;
      }
    },

    async extendSession() {
      this.$nuxt.$emit('notification', `We've just extended your session again`);
      this.logExtendSession();
      await this.$nuxt.$authService.refreshSession();
      this.isOpen = false;
    },
  },
};
